import { ReactElement, useContext, useRef, useState } from "react";
import { GlobalContext } from "./GlobalContext";
import MiscService from "services/MiscService";
import { Button, Form } from "react-bootstrap";

export interface IFileUploadEntryProps {
    onChange: (newVal: string) => void;
    className?: string;
    defaultValue?: string;
    title: string | ReactElement;
    allowMultiple?: boolean;
    rows?: number;
    includeTitle?: boolean;
}

const FileUploadEntry = (props: IFileUploadEntryProps) => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const attachFileRef = useRef<HTMLInputElement | null>(null);
    const [RunningSubmission, setRunningSubmission] = useState(false);

    const startAttach = () => {
        attachFileRef.current?.click();
    };

    const attachCompleteAsync = async (event: React.ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation();
        event.preventDefault();
        var file = event?.currentTarget?.files?.[0];

        if (file) {
            const formData = new FormData();
            const fileSize = file.size;
            const megs = fileSize / 1048576;

            if (megs > 25) {
                alert("The file you're trying to attach is too large");
                return false;
            }

            formData.append("file", file);
            setRunningSubmission(true);
            var accessToken = await globalContextRef.current.getAccessTokenAsync();
            var url = await MiscService.uploadMarkdownFileAsync(accessToken, formData);
            setRunningSubmission(false);

            if (url) {
                let entryTitle = "";
                if (props.includeTitle) {
                    entryTitle = window.prompt("Enter a title for the file", "") || "";
                    url = entryTitle + "|" + url;
                }

                if (props.allowMultiple) {
                    props.onChange(url + (props.defaultValue ? "," + props.defaultValue : ""));
                }
                else {
                    props.onChange(url);
                }
            }
            else {
                alert("The file could not be attached.");
            }
        }
    };

    return (
        <>
            <input
                type='file'
                id='attachPhotoRef'
                ref={attachFileRef}
                onChange={attachCompleteAsync}
                style={{ display: 'none' }} />

            <Form.Group className="mb-3">
                <Form.Label style={{ margin: "0" }}>
                    {props.title}
                    <Button
                        className="mb-3 btn btn-primary"
                        style={{
                            "marginLeft": "10px",
                            "fontSize": "10px",
                            "padding": "4px",
                            "position": "relative",
                            "bottom": "-6px"
                        }}
                        onClick={startAttach}>Upload</Button>
                </Form.Label>
                {
                    props.allowMultiple &&
                    <Form.Control
                        as="textarea"
                        rows={props.rows || 4}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                props.onChange(e.target.value);
                            }
                        }
                        value={props.defaultValue}
                    />
                }
                {
                    !props.allowMultiple &&
                    <Form.Control
                        type="text"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            props.onChange(e.target.value);
                        }}
                        value={props.defaultValue}
                    />
                }
            </Form.Group>
        </>
    );
}

export default FileUploadEntry;